<app-navbar></app-navbar>
<app-forms></app-forms>
<app-footer></app-footer>
